<template>
  <Timer
    :starttime="submission_start_date"
    :endtime="submission_end_date"  
    trans='{  
    "day":"days",
    "hours":"hours",
    "minutes":"minutes",
    "seconds":"seconds",
    "expired":"Event has been expired.",
    "running":"Till the end of event.",
    "upcoming":"Till start of event.",
    "status": {
    "expired":"Expired",
    "running":"Running",
    "upcoming":"Future"
    }}'
  ></Timer>
</template>

<script>
import Timer from './Timer.vue';
import API from '../API';
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";

export default {
  name: 'TimerBox',
  components: {
    Timer
  },

  props: {
    startDate: {
      default: false
    },
    endDate: {
      default: false
    }
  },

  data() {
    return {
      submission_start_date: '',
      submission_end_date: '',
    }
  },

  created () {
    this.submission_start_date = dayjs(this.startDate).format('MMM D, YYYY HH:mm:ss');
    this.submission_end_date = dayjs(this.endDate).format("MMM D, YYYY HH:mm:ss");
    // this.fetchData();
  },

  methods: {
    fetchData() {
      let that = this;
      API.get('/configs/submission_deadline').then(response => {
        //that.submission_start_date = dayjs(response.data.submission_start_date).format('MMM D, YYYY HH:mm:ss');
        //that.submission_end_date = dayjs(response.data.submission_end_date).format("MMM D, YYYY HH:mm:ss");
      });
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ./src/components/TimerBox.vue